import { createAction, props } from '@ngrx/store';
import { Quote } from '@shared/models/quote';

export const updateOpportunityValues = createAction(
  '[Opportunities] Update Opportunity Values',
  props<{
    opportunityId: number;
    quotes: Quote[];
  }>(),
);
